var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,7.5A8.5,8.5,0,1,0,24.5,16,8.51,8.51,0,0,0,16,7.5Zm0,15A6.51,6.51,0,0,1,10.9,20,6.42,6.42,0,0,1,14,17.86a3.48,3.48,0,0,0,4,0A6.42,6.42,0,0,1,21.1,20,6.51,6.51,0,0,1,16,22.5ZM14.5,15A1.5,1.5,0,1,1,16,16.5,1.5,1.5,0,0,1,14.5,15Zm7.63,3.13a8.37,8.37,0,0,0-2.85-1.95A3.58,3.58,0,0,0,19.5,15a3.5,3.5,0,0,0-7,0,3.58,3.58,0,0,0,.22,1.18,8.37,8.37,0,0,0-2.85,1.95A6.27,6.27,0,0,1,9.5,16a6.5,6.5,0,0,1,13,0A6.27,6.27,0,0,1,22.13,18.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,15H29.45A13.5,13.5,0,0,0,17,2.55V1H15V2.55A13.5,13.5,0,0,0,2.55,15H1v2H2.55A13.5,13.5,0,0,0,15,29.45V31h2V29.45A13.5,13.5,0,0,0,29.45,17H31ZM17,27.45V26H15v1.45A11.52,11.52,0,0,1,4.55,17H6V15H4.55A11.52,11.52,0,0,1,15,4.55V6h2V4.55A11.52,11.52,0,0,1,27.45,15H26v2h1.45A11.52,11.52,0,0,1,17,27.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseAssignment);
export default __webpack_public_path__ + "static/media/courseAssignment.e26f3b0f45645a3422e1e95db62124c5.svg";
export { ForwardRef as ReactComponent };